/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Batch_No_Presets_TitleInputs */

const en_explorer_info_batch_no_presets_title = /** @type {(inputs: Explorer_Info_Batch_No_Presets_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No export presets`)
};

const fr_explorer_info_batch_no_presets_title = /** @type {(inputs: Explorer_Info_Batch_No_Presets_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun préréglage d'exportation`)
};

const de_explorer_info_batch_no_presets_title = /** @type {(inputs: Explorer_Info_Batch_No_Presets_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Exportvoreinstellungen`)
};

const it_explorer_info_batch_no_presets_title = /** @type {(inputs: Explorer_Info_Batch_No_Presets_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun preset di esportazione`)
};

const ru_explorer_info_batch_no_presets_title = /** @type {(inputs: Explorer_Info_Batch_No_Presets_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нет настроек экспорта`)
};

const es_explorer_info_batch_no_presets_title = /** @type {(inputs: Explorer_Info_Batch_No_Presets_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay preajustes de exportación`)
};

const zh_cn2_explorer_info_batch_no_presets_title = /** @type {(inputs: Explorer_Info_Batch_No_Presets_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无导出预设`)
};

const ja_explorer_info_batch_no_presets_title = /** @type {(inputs: Explorer_Info_Batch_No_Presets_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エクスポートプリセットなし`)
};

const hi_explorer_info_batch_no_presets_title = /** @type {(inputs: Explorer_Info_Batch_No_Presets_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई निर्यात प्रीसेट नहीं`)
};

const pt_pt2_explorer_info_batch_no_presets_title = /** @type {(inputs: Explorer_Info_Batch_No_Presets_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem predefinições de exportação`)
};

/**
* | output |
* | --- |
* | "No export presets" |
*
* @param {Explorer_Info_Batch_No_Presets_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_batch_no_presets_title = /** @type {((inputs?: Explorer_Info_Batch_No_Presets_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Batch_No_Presets_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_info_batch_no_presets_title(inputs)
	if (locale === "de") return de_explorer_info_batch_no_presets_title(inputs)
	if (locale === "it") return it_explorer_info_batch_no_presets_title(inputs)
	if (locale === "ru") return ru_explorer_info_batch_no_presets_title(inputs)
	if (locale === "es") return es_explorer_info_batch_no_presets_title(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_info_batch_no_presets_title(inputs)
	if (locale === "ja") return ja_explorer_info_batch_no_presets_title(inputs)
	if (locale === "hi") return hi_explorer_info_batch_no_presets_title(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_info_batch_no_presets_title(inputs)
	return en_explorer_info_batch_no_presets_title(inputs)
});